import { css as e, keyframes as t, styled as n } from "styled-components";
import { EV_EASING as r, EV_ENTER as i, EV_IDLE as a, EV_WEB_ENTER_KEYFRAMES as o, EV_WEB_IDLE_KEYFRAMES as s } from "@maat/assets";
//#region src/components/EventAnimation/EventAnimation.styled.ts
var c = (e) => `cubic-bezier(${r[e].join(",")})`, l = (e) => Object.fromEntries(Object.keys(e).map((n) => [n, t`${e[n]}`])), u = l(o), d = l(s), f = Object.keys(i).map((t) => {
	let { dur: n, easing: r } = i[t];
	return e`
        .e-${t} {
            animation: ${u[t]} var(--d, ${n}ms) ${c(r)} var(--t, 0ms) both;
        }
    `;
}), p = Object.keys(a).map((t) => {
	let { duration: n, easing: r } = a[t];
	return e`
        .i-${t} {
            animation: ${d[t]} ${n}ms ${c(r)} var(--dl, 0ms) infinite;
        }
    `;
}), m = n.svg`
    display: block;
    flex-shrink: 0;
    max-width: 100%;
    height: auto;

    /* Added on mount, removed once the sequence lands — after which this is static SVG. */
    &.pl {
        ${f}
    }

    &.id {
        ${p}
    }

    /* The resting frame is already the artwork, so there is nothing to substitute —
       everything simply stops. */
    @media (prefers-reduced-motion: reduce) {
        * {
            animation: none !important;
        }
    }
`;
//#endregion
export { m as EventAnimationSvg };
